__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("launchdarkly-vue-client-sdk", "2.5.0", () => (Promise.all([__webpack_require__.e(910), __webpack_require__.e(50)]).then(() => (() => (__webpack_require__(6910))))));
			register("pinia", "4.0.3", () => (Promise.all([__webpack_require__.e(343), __webpack_require__.e(50)]).then(() => (() => (__webpack_require__(1343))))));
			register("vue-i18n", "11.4.6", () => (Promise.all([__webpack_require__.e(277), __webpack_require__.e(50)]).then(() => (() => (__webpack_require__(4277))))));
			register("vue", "3.5.31", () => (__webpack_require__.e(539).then(() => (() => (__webpack_require__(539))))));
			register("vuetify", "4.1.4", () => (Promise.all([__webpack_require__.e(659), __webpack_require__.e(50), __webpack_require__.e(263)]).then(() => (() => (__webpack_require__(9644))))));
			initExternal(3991);
			initExternal(8158);
			initExternal(5008);
			initExternal(4823);
			initExternal(8313);
			initExternal(7134);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};